import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { PlanTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PlanTypeCreateDto,
  PlanTypeDto,
  PlanTypeExcelDownloadDto,
  PlanTypeUpdateDto,
} from '../proxy/controlling/dtos/plan-type';
import { PLANTYPE_CONFIG, PLANTYPE_FIELDS } from './plan-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-plan-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, PlanTypeService, ConfirmationService],
  templateUrl: './plan-type.html',
  styleUrl: './plan-type.scss',
})
export class PlanType extends BaseCrudComponent<
  PlanTypeDto,
  PlanTypeCreateDto,
  PlanTypeUpdateDto,
  PlanTypeExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(PlanTypeService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('PlanType', ids),
  };
  config = PLANTYPE_CONFIG;
  fields = PLANTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: PlanTypeDto): PlanTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      description: data.description,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PlanType';
  }
}
